import type { ComponentType, ReactNode } from "react";
import { useLocation, useMatches } from "react-router";
import type { ShellRouteHandle } from "@/app/workspace/AppShell";
import { type CrashFallbackProps, ErrorBoundary } from "@/shared/ui/ErrorBoundary";

export function RouteTransition({
  fallback,
  children,
}: {
  fallback: ComponentType<CrashFallbackProps>;
  children: ReactNode;
}) {
  const { pathname } = useLocation();
  const mountKey = useRouteMountKey();

  return (
    <ErrorBoundary resetKey={pathname} fallback={fallback}>
      <div key={mountKey} className="route-enter flex h-full min-h-0 flex-1 flex-col">
        {children}
      </div>
    </ErrorBoundary>
  );
}

export function useRouteMountKey(): string {
  const { pathname } = useLocation();
  const matches = useMatches();
  const route = matches.at(-1);
  const handle = route?.handle as ShellRouteHandle | undefined;
  return route && handle?.keepMountedAcrossSegments === true ? route.id : pathname;
}
